import loanStatus from '~/modules/loans/utils/loan-status'

export default {
  computed: {
    status () {
      return loanStatus(this.loan)
    },
  },
}
